export default "/fonts/vendor/simple-line-icons/Simple-Line-Icons.eot?85e8c542d5e137beecf94e0132812855";